module.exports = __webpack_public_path__ + "media/components/users/integrations/images/twilio-8b97673f3418c91aec298ef5a1cf90d7.svg";